module.exports = __webpack_public_path__ + "img/3.06.thmb.3a70a517.jpg";